var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vca-map',{ref:"map",attrs:{"disabled":true,"hideButtons":_vm.mappedLocation.length <= 1},model:{value:(_vm.mappedLocation),callback:function ($$v) {_vm.mappedLocation=$$v},expression:"mappedLocation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }